import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";
import { getUserType } from "src/utils/localStorageHelper";

export const putAttendances = ({ data }) => {
  const userType = getUserType();

  return api.put(`${userType}/attendances`, data);
};

export const usePutAttendancesMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: putAttendances,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries(["attendances"]);
    },
    ...restConfig,
  });
};
